<template>
    <div class="v-checkbox-list">
        <div v-for="item in filter"
             :key="item.id"
             :class="['v-checkbox-list__item', {'is-checked': item.checked}, {'is-disabled': item.disabled}]"
             @click="item.disabled ? '' : item.checked = !item.checked">
            <span v-html="item.title">{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['filter']
};
</script>
